import { useCallback } from "react";
import { MUTATIONS } from "..";
import { useSnackbarMutation } from "../../hooks";
import { ServiceTypeListItem } from "../models";

type ServiceTypeListItemOrId = ServiceTypeListItem | string;

export function useReorderServiceListItems(onItemsReordered: () => void) {
  const [invokeReorderListItems, { loading, error }] = useSnackbarMutation(
    MUTATIONS.REORDER_SERVICE_TYPE_LIST_ITEMS,
    {
      onCompleted: () => {
        onItemsReordered();
      },
    }
  );

  const reorderListItems = useCallback(
    (item: ServiceTypeListItemOrId, moveIndex: number) => {
      let id: string;
      if (typeof item === "string") {
        id = item;
      } else {
        id = item.id as string;
      }

      invokeReorderListItems({
        variables: {
          id,
          moveIndex,
        },
      });
    },
    [invokeReorderListItems]
  );

  return {
    reorderListItems,
    loading,
    error,
  };
}
